import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Service } from "@/types/Service"; // Adjust path if needed

interface ServiceState {
    services: Service[];
    loading: boolean;
    error: string | null;
}

const initialState: ServiceState = {
    services: [],
    loading: false,
    error: null,
};

const serviceSlice = createSlice({
    name: "service",
    initialState,
    reducers: {
        // Add a new service to the state array
        addService(state, action: PayloadAction<Service>) {
            state.services.push(action.payload);
        },

        // Remove an existing service by id
        removeService(state, action: PayloadAction<number>) {
            state.services = state.services.filter(
                (service) => service.id !== action.payload
            );
        },

        // Update an existing service by matching on id
        updateService(state, action: PayloadAction<Service>) {
            const updated = action.payload;
            const index = state.services.findIndex((svc) => svc.id === updated.id);
            if (index !== -1) {
                state.services[index] = updated;
            }
        },

        setServices(state, action: PayloadAction<Service[]>) {
            state.services = action.payload;
        },
    },
});

export const {
    addService,
    removeService,
    updateService,
    setServices,
} = serviceSlice.actions;
export default serviceSlice.reducer;